"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TIMEZONES_MAP = exports.COUNTRY_CODE_CURRENCY_MAP = exports.getCountryCodeByCountryName = exports.getCountryCodeByPhoneCode = exports.getEmojiFlag = exports.listCountries = exports.getCountry = void 0;
const countries_list_1 = require("countries-list");
const countries_and_timezones_1 = __importDefault(require("countries-and-timezones"));
const country_currency_map_1 = __importDefault(require("country-currency-map"));
/**
 * Returns country info of type Country from 2 letter country code.
 * @param countryCode eg: AU, IN, US
 */
function getCountry(countryCode) {
    const country = countries_list_1.countries[countryCode];
    if (country) {
        return {
            ...country,
            code: countryCode,
            phone: `+${country.phone}`,
        };
    }
    return undefined;
}
exports.getCountry = getCountry;
/**
 * Returns list of all countries
 */
function listCountries() {
    return Object.keys(countries_list_1.countries).map(code => ({
        code,
        ...countries_list_1.countries[code],
        phone: `+${countries_list_1.countries[code].phone}`,
    }));
}
exports.listCountries = listCountries;
/**
 * Get emoji flag of country by 2 letter code
 * @param countryCode eg: AU, IN, US
 */
function getEmojiFlag(countryCode) {
    const country = countries_list_1.countries[countryCode];
    return country ? country.emoji : undefined;
}
exports.getEmojiFlag = getEmojiFlag;
/**
 * Given a country phone code (like +61 / +91), this method will returns country code ("AU"/"IN")
 * @param phone
 */
function getCountryCodeByPhoneCode(phone) {
    const country = listCountries().find(_country => _country.phone === phone);
    return country === null || country === void 0 ? void 0 : country.code;
}
exports.getCountryCodeByPhoneCode = getCountryCodeByPhoneCode;
function getCountryCodeByCountryName(name) {
    const country = listCountries().find(_country => _country.name === name);
    return country === null || country === void 0 ? void 0 : country.code;
}
exports.getCountryCodeByCountryName = getCountryCodeByCountryName;
exports.COUNTRY_CODE_CURRENCY_MAP = country_currency_map_1.default.getCurrencyList();
exports.TIMEZONES_MAP = countries_and_timezones_1.default.getAllTimezones();
//# sourceMappingURL=countries.js.map